<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-col :span="6">
        <el-form-item label="小区名称" prop="propertyId">
          <el-select
            size="small"
            v-model="query.communityId"
            filterable
            placeholder="请选择小区"
            style="width: 100%;"
            @change="userDistricts"
          >
            <el-option
              v-for="item in allPropertyList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="速记码">
          <el-input size="small" placeholder="请输入速记码" clearable v-model="query.shortCode" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="姓名">
          <el-input size="small" placeholder="请输入姓名" clearable v-model="query.name" />
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="租户类型">
          <el-select size="small" v-model="query.departmentRentType" clearable placeholder="全部">
            <el-option
              style="padding-left: 10px;"
              v-for="item in departmentRentTypeList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="身份证">
          <el-input size="small" placeholder="请输入身份证" clearable v-model="query.idCard" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="电话">
          <el-input size="small" placeholder="请输入电话" clearable v-model="query.mobile" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="房间">
          <el-input size="small" placeholder="请输入房间" clearable v-model="query.propertyName" />
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="房间状态">
          <el-select size="small" v-model="query.status" clearable placeholder="全部">
            <el-option
              style="padding-left: 10px;"
              v-for="item in statusList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="工作单位">
          <el-select
            size="small"
            v-model="query.companyName"
            style="width: 100%;"
            filterable
            clearable
            placeholder="全部"
          >
            <el-option
              style="padding-left: 10px;"
              v-for="item in companyNameTypeList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8" style="margin-left: 3%;">
        <el-form-item size="small" label="入住时间 从" prop="dateRange">
          <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.timeStart"
              type="datetime"
              default-time="00:00:00"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.timeEnd"
              type="datetime"
              default-time="23:59:59"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
            
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
        </el-form-item>
      </el-col>
      <el-col :span="6" style="margin-left: 12%;">
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="submitSearchForm">搜索</el-button>
          <el-button icon="el-icon-delete" @click="searchReset">清空</el-button>
        </el-form-item>
      </el-col>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :cell-style="cellStyle"
      :row-style="rowStyle"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.departmentrenter_add"
          @click="openDepartmentrenterAddDialog"
          >租赁登记
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.departmentrenter_add"
          @click="exportExcel"
          >导出
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.departmentrenter_view"
          @click="openDepartmentrenterViewDialog(scope.row)"
          :hidden="hideApplyBtn(scope.row)"
          >查看
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.departmentrenter_edit"
          @click="openDepartmentrenterEditDialog(scope.row)"
          :hidden="hideApplyBtn(scope.row)"
          >修改
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-upload2"
          v-if="permission.departmentrenter_edit"
          @click="openDepartmentrenterSwopDialog(scope.row)"
          :hidden="hideApplyBtn(scope.row)"
          >换房
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-upload2"
          v-if="permission.departmentrenter_edit"
          @click="openDepartmentrenterCheckOutDialog(scope.row)"
          :hidden="hideApplyBtn(scope.row)"
          >退房
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="租赁登记"
      :visible.sync="openDepartmentrenterAddDialogFlag"
      :modal-append-to-body="false"
      @close="quitDepartmentrenterAddDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="departmentrenterAddFormRef"
          v-model="departmentrenterAddForm"
          :option="departmentrenterAddOption"
          @submit="departmentrenterAddSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="departmentrenterAddDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="查看"
      :visible.sync="openDepartmentrenterViewDialogFlag"
      append-to-body
      style="margin-top:1vh;"
      @close="quitDepartmentrenterViewDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="departmentrenterViewFormRef"
          v-model="departmentrenterViewForm"
          :option="departmentrenterViewOption"
        >
          <!--          <template slot-scope="scope" slot="menuForm">-->
          <!--            <el-button @click="departmentrenterViewDialog">返回</el-button>-->
          <!--          </template>-->
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="openDepartmentrenterEditDialogFlag"
      @opened="renterEditDialogOpened"
      append-to-body
      style="margin-top:1vh;"
      @close="quitDepartmentrenterEditDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="departmentrenterEditFormRef"
          v-model="departmentrenterEditForm"
          :option="departmentrenterEditOption"
          @submit="departmentrenterEditSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="departmentrenterEditDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="换房"
      :visible.sync="openDepartmentrenterSwopDialogFlag"
      append-to-body
      style="margin-top:1vh;"
      @close="quitDepartmentrenterSwopDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="departmentrenterSwopFormRef"
          v-model="departmentrenterSwopForm"
          :option="departmentrenterSwopOption"
          @submit="departmentrenterSwopSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="departmentrenterSwopDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="退房"
      :visible.sync="openDepartmentrenterCheckOutDialogFlag"
      append-to-body
      style="margin-top:1vh;"
      @close="quitDepartmentrenterCheckOutDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="departmentrenterCheckOutFormRef"
          v-model="departmentrenterCheckOutForm"
          :option="departmentrenterCheckOutOption"

        >
          <template slot-scope="scope" slot="menuForm">
            <el-button type="primary" :disabled=forbidden @click="departmentrenterCheckOutSubmit">结算</el-button>
            <el-button @click="departmentrenterCheckOutDialog">返回</el-button>
          </template>
          <template slot="bind" slot-scope="scope">
            <el-button type="primary"  @click="countPrice">计算</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getDepartmentRenterByRoommateName,
  getRecordInfo,
  getDepartmentRenterCheckOutAmount,
  departmentRenterCheckOutBill,
  departmentRenterRoomChange,
  getDictionaryWithIntKey,
  getRentAmount,
  getDownloadList,
  getAllFeeItem,
} from '@/api/v4ward/department/departmentrenter';
import { mapGetters } from 'vuex';
import departmentrenterAddOption from './departmentrenter-add-option';
import departmentrenterEditOption from './departmentrenter-edit-option';
import departmentrenterSwopOption from './departmentrenter-swop-option';
import departmentrenterCheckOutOption from './departmentrenter-check-out-option';
import departmentrenterViewOption from './departmentrenter-view-option';
import { getDepartmentCommunityTree } from '../../../api/v4ward/property/baseproperty';
import { getDepartmentCompanyList } from '../../../api/v4ward/department/departmentcompany';
export default {
  data() {
    return {
      allPropertyList: [],
      departmentRentTypeList: [],
      statusList: [],
      sexList: [],
      companyNameTypeList: [],
      billCutBankList: [],
      forbidden:true,
      form: {},
      query: {
        timeEnd:'',
        timeStart:'',
        name:'',
        shortCode:'',
        departmentRentType:'',
        idCard:'',
        mobile:'',
        propertyName:'',
        status:''
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 80,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        selection: false,
        labelWidth: 150,
        rowKey:'rentRecordId',
        align: 'center',
        column: [
          {
            label: '公寓信息表id',
            prop: 'id',
            hide: true,
            viewDisplay: false,
          },
          {
            width: 150,
            label: '房间名称',
            prop: 'propertyName',
          },
          {
            label: '房间状态',
            prop: 'status',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=department_status',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '租赁记录id',
            prop: 'rentRecordId',
            viewDisplay: false,
            hide: true,
          },
          {
            label: '公寓床位',
            prop: 'bunkNum',
          },
          {
            label: '姓名',
            prop: 'name',
          },
          {
            label: '电话',
            width: 130,
            prop: 'mobile',
          },
          {
            label: '性别',
            prop: 'sex',
            width: 50,
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
              dataType: 'number',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=sex',
          },
          {
            label: '身份证',
            width: 150,
            prop: 'idCard',
            rules: [
              {
                required: true,
                message: '请输入身份证',
                trigger: 'change',
              },
            ],
          },
          {
            label: '租户类型',
            prop: 'departmentRentType',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=department_rent_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '工作单位',
            width: 150,
            prop: 'companyName',
            type: 'select',
            dicUrl: 'api/v4ward/departmentCompany/getDepartmentCompanyList',
            props: { label: 'companyName', value: 'id' },
          },
          {
            label: '起租时间',
            width: 150,
            prop: 'startDate',
          },
          {
            label: '减免金额',
            prop: 'derateMoney',
          },
          {
            label: '划扣账户',
            width: 150,
            prop: 'bankCardNo',
          },
          {
            label: '划扣银行',
            prop: 'bank',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=bill_cutBank',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '押金金额',
            prop: 'deposit',
          },
          {
            label: '押金编号',
            prop: 'depositNo',
          },
          {
            label: '电费起码',
            prop: 'electricityBeginNum',
          },
          {
            label: '水费起码',
            prop: 'waterBeginNumber',
          },
          {
            label: '占铺位数',
            prop: 'bedUsingNum',
          },
        ],
      },
      data: [],
      departmentrenterAddOption: departmentrenterAddOption,
      departmentrenterEditOption: departmentrenterEditOption,
      departmentrenterSwopOption: departmentrenterSwopOption,
      departmentrenterCheckOutOption: departmentrenterCheckOutOption,
      departmentrenterViewOption: departmentrenterViewOption,
      departmentrenterViewForm: {},
      departmentrenterAddForm: {bank:1,},
      departmentrenterCheckOutForm: {},
      departmentrenterEditForm: {},
      departmentrenterSwopForm: {},
      openDepartmentrenterCheckOutDialogFlag: false,
      openDepartmentrenterAddDialogFlag: false,
      openDepartmentrenterEditDialogFlag: false,
      openDepartmentrenterSwopDialogFlag: false,
      openDepartmentrenterViewDialogFlag: false,
      trackRecordId: '',
      RenterVO: {},
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.departmentrenter_add, false),
        viewBtn: this.vaildData(this.permission.departmentrenter_view, false),
        delBtn: this.vaildData(this.permission.departmentrenter_delete, false),
        editBtn: this.vaildData(this.permission.departmentrenter_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getDepartmentCommunityTree({}).then((data) => {
      this.allPropertyList = data.data;
      if (data.data.length > 0) {
        this.query.communityId = data.data[0].id;
        this.onLoad();
      }
    });
  },
  mounted() {
    this.initAllstatusList();
  },
  methods: {
    checkOutShouldAmount(){
      let sum = 0;
      if(this.departmentrenterCheckOutForm.electricityAmount){
        sum = sum+this.departmentrenterCheckOutForm.electricityAmount
      }
      if(this.departmentrenterCheckOutForm.waterAmount){
        sum = sum+this.departmentrenterCheckOutForm.waterAmount
      }
      if(this.departmentrenterCheckOutForm.meanElectricityAmount){
        sum = sum+this.departmentrenterCheckOutForm.meanElectricityAmount
      }
      if(this.departmentrenterCheckOutForm.meanWaterAmount){
        sum = sum+this.departmentrenterCheckOutForm.meanWaterAmount
      }
      if(this.departmentrenterCheckOutForm.meanHealthAmount){
        sum = sum+this.departmentrenterCheckOutForm.meanHealthAmount
      }
      if(this.departmentrenterCheckOutForm.meanRentAmount){
        sum = sum+this.departmentrenterCheckOutForm.meanRentAmount
      }
      if(this.departmentrenterCheckOutForm.propertyFeeAmount){
        sum = sum+this.departmentrenterCheckOutForm.propertyFeeAmount
      }

      this.departmentrenterCheckOutForm.shouldAmount = sum;
    },
    userDistricts(e) {
      this.$forceUpdate();
    },
    quitDepartmentrenterViewDialog() {
      this.$refs.departmentrenterViewFormRef.resetForm();
    },
    ///////////////////////////////操作按钮隐藏判断 start ////////////////////
    hideApplyBtn(row) {
      //    --》隐藏按钮
      return row.rentRecordId <= 0;
    },
    exportExcel() {
      if (this.query.dateStartRange) {
        this.query.timeStart = this.query.dateStartRange[0];
        this.query.timeEnd = this.query.dateStartRange[1];
      }
      this.$confirm('确定导出所有数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        getDownloadList(Object.assign({}, this.query)).then(({ data }) => {
          // 需要导出的数据，可以动态获取
          import('@/vendor/Export2Excel.js').then((excel) => {
            // 导入js模块
            const tHeader = [
              '房间名称',
              '姓名',
              '联系方式',
              '性别',
              '身份证',
              '公寓租户类型',
              '工作单位',
              '租赁开始日期',
              '单位减免金额',
              '银行卡号',
              '银行卡归属银行',
              '押金',
              '押金编号',
              '电费起码',
              '水费起码',
              '占用床位',
            ]; // 导出excel 的标题
            const filterVal = [
              'propertyName',
              'name',
              'mobile',
              'sex',
              'idCard',
              'departmentRentType',
              'companyName',
              'startDate',
              'derateMoney',
              'bankCardNo',
              'bank',
              'deposit',
              'depositNo',
              'electricityBeginNum',
              'waterBeginNumber',
              'bedUsingNum',
            ]; // 每个标题对应的字段
            const list = (data || []).map((item, key) => {
              // 通过 map 方法遍历，组装数据成上面的格式
              return {
                propertyName: item.propertyName,
                name: item.name,
                mobile: item.mobile,
                sex: this.sexTosexName(item.sex),
                idCard: item.idCard,
                departmentRentType: this.departmentRentTypeName(item.departmentRentType),
                companyName: this.companyNameTypeName(item.companyName),
                startDate: item.startDate
                  ? this.dayjs(item.startDate).format('YYYY-MM-DD HH:mm:ss')
                  : '',
                derateMoney: item.derateMoney,
                bankCardNo: item.bankCardNo,
                bank: this.billCutBankTypeName(item.bank),
                deposit: item.deposit,
                depositNo: item.depositNo,
                electricityBeginNum: item.electricityBeginNum,
                waterBeginNumber: item.waterBeginNumber,
                bedUsingNum: item.bedUsingNum,
              };
            });
            if (list.length > 0) {
              const data = this.formatJson(filterVal, list); // 生成json数据
              excel.export_json_to_excel({
                // 调用excel方法生成表格
                header: tHeader,
                data,
                filename: '公寓租户查询' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
              });
            } else {
              this.$message.error('暂无有效数据');
            }
          });
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    sexTosexName(sex) {
      var sexName = '';
      this.sexList.forEach(function (value, index, array) {
        if (value.dictKey == sex) {
          sexName = value.dictValue;
          return;
        }
      });
      return sexName;
    },
    departmentRentTypeName(departmentRentType) {
      var departmentRentTypeName = '';
      this.departmentRentTypeList.forEach(function (value, index, array) {
        if (value.dictKey == departmentRentType) {
          departmentRentTypeName = value.dictValue;
          return;
        }
      });
      return departmentRentTypeName;
    },
    companyNameTypeName(companyName) {
      var companyNameTypeName = '';
      this.companyNameTypeList.forEach(function (value, index, array) {
        if (value.id == companyName) {
          companyNameTypeName = value.companyName;
          return;
        }
      });
      return companyNameTypeName;
    },
    billCutBankTypeName(bank) {
      var billCutBankTypeName = '';
      this.billCutBankList.forEach(function (value, index, array) {
        if (value.dictKey == bank) {
          billCutBankTypeName = value.dictValue;
          return;
        }
      });
      return billCutBankTypeName;
    },
    quitDepartmentrenterAddDialog() {
      this.openDepartmentrenterAddDialogFlag = false;
      this.$refs.departmentrenterAddFormRef.resetForm();
    },
    quitDepartmentrenterEditDialog() {
      this.openDepartmentrenterEditDialogFlag = false;
      this.$refs.departmentrenterEditFormRef.resetForm();
    },
    quitDepartmentrenterCheckOutDialog() {
      this.openDepartmentrenterCheckOutDialogFlag = false;
      this.RenterVO = {};
      this.$refs.departmentrenterCheckOutFormRef.resetForm();
    },
    quitDepartmentrenterSwopDialog() {
      this.openDepartmentrenterSwopDialogFlag = false;
      this.RenterVO = {};
      this.$refs.departmentrenterSwopFormRef.resetForm();
    },
    initAllstatusList() {
      getDictionaryWithIntKey('department_status').then((data) => {
        this.statusList = data.data;
      });
      getDictionaryWithIntKey('department_rent_type').then((data) => {
        this.departmentRentTypeList = data.data;
      });
      getDictionaryWithIntKey('sex').then((data) => {
        this.sexList = data.data;
      });
      getDepartmentCompanyList().then((data) => {
        this.companyNameTypeList = data.data;
      });
      getDictionaryWithIntKey('bill_cutBank').then((data) => {
        this.billCutBankList = data.data;
      });
    },
    countPrice() {
      if (
        this.departmentrenterCheckOutForm.electricityEedNum === '' ||
        this.departmentrenterCheckOutForm.electricityEedNum === undefined
      ) {
        this.$message.error('请输入电费止码!');
      } else {
        if (
          this.departmentrenterCheckOutForm.endDate === '' ||
          this.departmentrenterCheckOutForm.endDate === undefined
        ) {
          this.$message.error('请选择退租时间!');
        } else {
          this.RenterVO.endDate = this.departmentrenterCheckOutForm.endDate;
          this.RenterVO.electricityEedNum = this.departmentrenterCheckOutForm.electricityEedNum;
          this.RenterVO.waterEedNumber = this.departmentrenterCheckOutForm.waterEedNumber;
          this.RenterVO.startDate = '';
          //计算的时候传0，会按照公寓退房规则计算
          this.RenterVO.departmentRoomChangeId = 0;
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
          getDepartmentRenterCheckOutAmount(this.RenterVO).then(
            (r) => {
              this.departmentrenterCheckOutForm.waterAmount = r.data.waterAmount;
              this.departmentrenterCheckOutForm.electricityAmount = r.data.electricityAmount;
              this.departmentrenterCheckOutForm.meanElectricityAmount =
                r.data.meanElectricityAmount;
              this.departmentrenterCheckOutForm.meanWaterAmount = r.data.meanWaterAmount;
              this.departmentrenterCheckOutForm.propertyFeeAmount = r.data.propertyFeeAmount;
              this.departmentrenterCheckOutForm.meanHealthAmount = r.data.meanHealthAmount;
              this.departmentrenterCheckOutForm.meanRentAmount = r.data.meanRentAmount;
              this.departmentrenterCheckOutForm.shouldAmount = r.data.shouldAmount;
              this.forbidden = false;
              loading.close();
            },
            (error) => {
              loading.close();
              console.log(error);
            }
          );
        }
      }
    },
    departmentrenterCheckOutSubmit(form, done) {
      this.$refs.departmentrenterCheckOutFormRef.validate(flag=>{
        if(flag){
          this.RenterVO.payWay = this.departmentrenterCheckOutForm.payWay;
          this.RenterVO.endDate = this.departmentrenterCheckOutForm.endDate;
          this.RenterVO.electricityEedNum = this.departmentrenterCheckOutForm.electricityEedNum;
          this.RenterVO.waterEedNumber = this.departmentrenterCheckOutForm.waterEedNumber;
          this.RenterVO.waterAmount = this.departmentrenterCheckOutForm.waterAmount;
          this.RenterVO.meanElectricityAmount = this.departmentrenterCheckOutForm.meanElectricityAmount;
          this.RenterVO.electricityAmount = this.departmentrenterCheckOutForm.electricityAmount;
          this.RenterVO.meanWaterAmount = this.departmentrenterCheckOutForm.meanWaterAmount;
          this.RenterVO.rentAmount = this.departmentrenterCheckOutForm.rentAmount;
          this.RenterVO.meanHealthAmount = this.departmentrenterCheckOutForm.meanHealthAmount;
          this.RenterVO.meanRentAmount = this.departmentrenterCheckOutForm.meanRentAmount;
          this.RenterVO.shouldAmount = this.departmentrenterCheckOutForm.shouldAmount;
          this.RenterVO.propertyFeeAmount = this.departmentrenterCheckOutForm.propertyFeeAmount;
          this.$confirm('确定已收款?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              departmentRenterCheckOutBill(this.RenterVO).then(
                () => {
                  this.onLoad();
                  this.$message.success('操作成功!');
                  this.RenterVO = {};
                  this.openDepartmentrenterCheckOutDialogFlag = false;
                  this.$refs.departmentrenterCheckOutFormRef.resetForm();
                  done();
                },
                (error) => {
                  done();
                  console.log(error);
                }
              );
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消',
              });
              done();
            });
        }
      })

    },
    departmentrenterSwopSubmit(form, done) {
      this.RenterVO.departmentRoomChangeId = form.departmentRoomChangeId;
      this.RenterVO.electricityBeginRoomChangeNum = form.electricityBeginRoomChangeNum;
      this.RenterVO.waterBeginRoomChangeNumber = form.waterBeginRoomChangeNumber;
      this.RenterVO.waterEedNumber = form.waterEedNumber;
      this.RenterVO.electricityEedNum = form.electricityEedNum;
      this.RenterVO.startDate = '';
      departmentRenterRoomChange(this.RenterVO).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.RenterVO = {};
          this.openDepartmentrenterSwopDialogFlag = false;
          this.$refs.departmentrenterSwopFormRef.resetForm();
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    departmentrenterEditSubmit(form, done) {
      add(form).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.openDepartmentrenterEditDialogFlag = false;
          this.$refs.departmentrenterEditFormRef.resetForm();
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    departmentrenterAddSubmit(form, done) {
      if("" != form.bankCardNo ){
        if("" == form.bank){
          this.$message.warning('划扣银行不能为空!');
          done();
          return;
        }
      }
      add(form).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.openDepartmentrenterAddDialogFlag = false;
          this.$refs.departmentrenterAddFormRef.resetForm();
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    departmentrenterCheckOutDialog() {
      this.openDepartmentrenterCheckOutDialogFlag = false;
      this.$refs.departmentrenterCheckOutFormRef.resetForm();
    },
    departmentrenterSwopDialog() {
      this.openDepartmentrenterSwopDialogFlag = false;
      this.$refs.departmentrenterSwopFormRef.resetForm();
    },
    departmentrenterEditDialog() {
      this.openDepartmentrenterEditDialogFlag = false;
      this.$refs.departmentrenterEditFormRef.resetForm();
    },
    departmentrenterAddDialog() {
      this.openDepartmentrenterAddDialogFlag = false;
      this.$refs.departmentrenterAddFormRef.resetForm();
    },
    openDepartmentrenterViewDialog(row) {
      getAllFeeItem({ departmentId: row.departmentId }).then((r) => {
        this.departmentrenterViewForm.waterAmount = r.data.data.waterAmount;
        this.departmentrenterViewForm.electricityAmount = r.data.data.electricityAmount;
        this.departmentrenterViewForm.meanElectricityAmount = r.data.data.meanElectricityAmount;
        this.departmentrenterViewForm.meanWaterAmount = r.data.data.meanWaterAmount;
        this.departmentrenterViewForm.meanHealthAmount = r.data.data.meanHealthAmount;
        this.departmentrenterViewForm.propertyFeeAmount = r.data.data.propertyFeeAmount;
        this.departmentrenterViewForm.rentAmount = r.data.data.rentAmount;
      });
      this.departmentrenterViewForm.name = row.name;
      this.departmentrenterViewForm.mobile = row.mobile;
      this.departmentrenterViewForm.sex = row.sex;
      this.departmentrenterViewForm.idCard = row.idCard;
      this.departmentrenterViewForm.companyName = row.companyName;
      this.departmentrenterViewForm.bankCardNo = row.bankCardNo;
      this.departmentrenterViewForm.bank = row.bank;
      this.departmentrenterViewForm.departmentRentType = row.departmentRentType;
      this.departmentrenterViewForm.derateMoney = row.derateMoney;
      this.departmentrenterViewForm.deposit = row.deposit;
      this.departmentrenterViewForm.depositNo = row.depositNo;
      this.departmentrenterViewForm.electricityBeginNum = row.electricityBeginNum;
      this.departmentrenterViewForm.waterBeginNumber = row.waterBeginNumber;
      this.departmentrenterViewForm.bedUsingNum = row.bedUsingNum;
      this.departmentrenterViewForm.propertyName = row.propertyName;
      this.departmentrenterViewForm.startDate = row.startDate;
      getDepartmentRenterByRoommateName({
        departmentId: row.departmentId,
      }).then((r) => {
        this.departmentrenterViewForm.roommateName = r.data.roommateName;
      });
      this.openDepartmentrenterViewDialogFlag = true;

      setTimeout(()=>{
        document.querySelector('body > div.el-dialog__wrapper > div[aria-label="查看"]').style = 'margin-top:1vh';
      })
    },
    openDepartmentrenterSwopDialog(row) {
      this.RenterVO = row;
      this.departmentrenterSwopForm.departmentId = row.departmentId;
      this.departmentrenterSwopForm.derateMoney = row.derateMoney;
      getDepartmentRenterByRoommateName({
        departmentId: row.departmentId,
      }).then((r) => {
        this.departmentrenterSwopForm.roommateName = r.data.roommateName;
      });
      getRentAmount({ departmentId: row.departmentId }).then((r) => {
        this.departmentrenterSwopForm.rentAmount = r.data.rentAmount;
      });
      this.openDepartmentrenterSwopDialogFlag = true;
      setTimeout(()=>{
        document.querySelector('body > div.el-dialog__wrapper > div[aria-label="换房"]').style = 'margin-top:1vh';
      })
    },
    openDepartmentrenterCheckOutDialog(row) {
      this.forbidden = true;
      this.RenterVO = row;
      this.departmentrenterCheckOutForm.depositNo = row.depositNo;
      this.departmentrenterCheckOutForm.departmentId = row.departmentId;
      this.departmentrenterCheckOutForm.deposit = row.deposit;
      this.departmentrenterCheckOutForm.derateMoney = row.derateMoney;
      getDepartmentRenterByRoommateName({
        departmentId: row.departmentId,
      }).then((r) => {
        this.departmentrenterCheckOutForm.roommateName = r.data.roommateName;
      });
      getRentAmount({ departmentId: row.departmentId }).then((r) => {
        this.departmentrenterCheckOutForm.rentAmount = r.data.rentAmount;
      });
      this.openDepartmentrenterCheckOutDialogFlag = true;

      setTimeout(()=>{
        document.querySelector('body > div.el-dialog__wrapper > div[aria-label="退房"]').style = 'margin-top:1vh';
      })
    },
    openDepartmentrenterEditDialog(row) {
      this.openDepartmentrenterEditDialogFlag = true;
      this.trackRecordId = row.rentRecordId;

      setTimeout(()=>{
        document.querySelector('body > div.el-dialog__wrapper > div[aria-label="修改"]').style = 'margin-top:1vh';
      })
    },
    openDepartmentrenterAddDialog() {
      this.departmentrenterAddForm.startDate = this.changeTime(new Date());
      this.openDepartmentrenterAddDialogFlag = true;
    },
    changeTime(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      let h = date.getHours();
      h = h < 10 ? '0' + h : h;
      let m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      let s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    renterEditDialogOpened() {
      this.$refs.departmentrenterEditFormRef.resetForm();
      getRecordInfo({ id: this.trackRecordId }).then(({ data }) => {
        this.departmentrenterEditForm.id = data.renterId;
        this.departmentrenterEditForm.rentRecordId = data.id;
        this.departmentrenterEditForm.name = data.name;
        this.departmentrenterEditForm.mobile = data.mobile;
        this.departmentrenterEditForm.sex = data.sex;
        this.departmentrenterEditForm.idCard = data.idCard;
        this.departmentrenterEditForm.departmentRentType = data.departmentRentType;
        this.departmentrenterEditForm.companyName = data.companyName;
        this.departmentrenterEditForm.derateMoney = data.derateMoney;
        this.departmentrenterEditForm.bankCardNo = data.bankCardNo;
        this.departmentrenterEditForm.bank = data.bank;
        this.departmentrenterEditForm.deposit = data.deposit;
        this.departmentrenterEditForm.depositNo = data.depositNo;
        this.departmentrenterEditForm.electricityBeginNum = data.electricityBeginNum;
        this.departmentrenterEditForm.waterBeginNumber = data.waterBeginNumber;
      });
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      
      this.query.communityId = this.allPropertyList[0].id;
      this.query.name = '';
      this.query.shortCode ='';
      this.query.departmentRentType = '';
      this.query.idCard = '';
      this.query.mobile = '';
      this.query.propertyName ='';
      this.query.status = '';
      this.query.timeStart=''
        this.query.timeEnd=''
      this.onLoad();
    },
    searchChange(params) {
     
      this.query.name = params.name;
      this.query.shortCode = params.shortCode;
      this.query.departmentRentType = params.departmentRentType;
      this.query.idCard = params.idCard;
      this.query.mobile = params.mobile;
      this.query.propertyName = params.propertyName;
      this.query.status = params.companyName;
      
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.allPropertyList.length > 0) {
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            for (let i = 0; i < data.records.length; i++) {
              if (data.records[i].rentRecordId == -1) {
                data.records[i].rentRecordId = i;
              }
            }
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          }
        );
      } else {
        this.loading = false;
      }
    },
    rowStyle({ row, column, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return {
          backgroundColor: '#eee',
          // color: '#fff',
        };
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      //根据房间状态调整字体样式
      if (columnIndex === 2) {
        if (row.status === 1) {
          return {
            color: 'green',
            fontWeight: 'bold',
            fontSize: '20',
          };
        } else {
          return {
            color: 'red',
            fontWeight: 'bold',
            fontSize: '20',
          };
        }
      }
    },
  },
  watch: {
    'departmentrenterAddForm.departmentId'() {
      getDepartmentRenterByRoommateName({
        departmentId: this.departmentrenterAddForm.departmentId,
      }).then((r) => {
        this.departmentrenterAddForm.roommateName = r.data.roommateName;
      });
      getRentAmount({ departmentId: this.departmentrenterAddForm.departmentId }).then((r) => {
        this.departmentrenterAddForm.rentAmount = r.data.rentAmount;
      });
    },
    'departmentrenterSwopForm.departmentRoomChangeId'() {
      getDepartmentRenterByRoommateName({
        departmentId: this.departmentrenterSwopForm.departmentRoomChangeId,
      }).then((r) => {
        this.departmentrenterSwopForm.roomChangeRoommateName = r.data.roommateName;
      });
      getRentAmount({ departmentId: this.departmentrenterSwopForm.departmentRoomChangeId }).then(
        (r) => {
          this.departmentrenterSwopForm.changeRentAmount = r.data.rentAmount;
        }
      );
    },
    'departmentrenterCheckOutForm.electricityAmount'() {
      this.checkOutShouldAmount();
    },
    'departmentrenterCheckOutForm.waterAmount'() {
      this.checkOutShouldAmount();
    },
    'departmentrenterCheckOutForm.meanElectricityAmount'() {
      this.checkOutShouldAmount();
    },
    'departmentrenterCheckOutForm.meanWaterAmount'() {
      this.checkOutShouldAmount();
    },
    'departmentrenterCheckOutForm.meanHealthAmount'() {
      this.checkOutShouldAmount();
    },
    'departmentrenterCheckOutForm.meanRentAmount'() {
      this.checkOutShouldAmount();
    },
    'departmentrenterCheckOutForm.propertyFeeAmount'() {
      this.checkOutShouldAmount();
    },
  },
};
</script>

<style>
  /deep/.el-input .el-input--small .is-disabled.redStyle .el-input__inner {
    color: red!important;
  }
</style>
